"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIXED_MINT_FEE_PER_NFT_IN_WEI = void 0;
exports.FIXED_MINT_FEE_PER_NFT_IN_WEI = "800000000000000"; // 0.0008 ETH
//# sourceMappingURL=constants.js.map